import { render, staticRenderFns } from "./ReviewSummaryExplanation.vue?vue&type=template&id=15d143e6&"
import script from "./ReviewSummaryExplanation.vue?vue&type=script&lang=js&"
export * from "./ReviewSummaryExplanation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSummaryExplanation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports